import { useEffect } from 'react';
import { FullLogo } from '@rsos/components/capstone/Layout/Navigation/common/logo/RapidSOSLogo';
import { Box } from '@rsos/components/capstone/base';
import { useFlag } from '@rsos/flags';
import NewLogin from '../Auth/Login/NewLogin';
import RebrandedFooter from './RebrandedFooter';
import styles from './RebrandedLanding.module.css';

const REBRAND_BLOG_URL = 'https://rapidsos.com/blog/meet-the-safety-network/';
const REBRAND_FALLBACK_URL = 'https://rapidsos.com/';

// Rebranded login experience, mirroring the b2b_hub LogInPage split layout: a
// marketing column alongside the login card on a white background.
const RebrandedLanding = () => {
  const useRebrandBlogUrl = useFlag('rebrand_blog_url');
  const rebrandNoteUrl = useRebrandBlogUrl
    ? REBRAND_BLOG_URL
    : REBRAND_FALLBACK_URL;

  useEffect(() => {
    document.body.classList.add('rebrandedLandingActive');
    return () => document.body.classList.remove('rebrandedLandingActive');
  }, []);

  return (
    <Box style={{ background: '#ffffff' }}>
      <div className={styles.landingContent}>
        <div className={styles.marketingColumn}>
          <Box style={{ marginBottom: 24 }}>
            <FullLogo height={40} />
          </Box>
          <div className={styles.marketingCopy}>
            <h2 className={styles.eyebrow}>RapidSOS Unite</h2>
            <h1 className={styles.headline}>
              You’re connecting to the Safety Network.
            </h1>
            <p className={styles.bodyCopy}>
              RapidSOS connects your agency to 723M+ devices, 250+ enterprises,
              and 23,500+ agencies, so every responder has the full picture
              before they arrive.
            </p>
            <a
              className={styles.rebrandNote}
              href={rebrandNoteUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Same trusted partner. New look. Learn why &gt;
            </a>
          </div>
          <div className={styles.marketingSpacer} />
        </div>
        <div className={styles.loginColumn}>
          <NewLogin />
        </div>
      </div>
      <RebrandedFooter />
    </Box>
  );
};

export default RebrandedLanding;
